import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function LocaleSEO() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    // Keep the keywords meta + <html lang> in sync with the active language.
    // The page title + description are owned by the useSeoMeta/useMetaDescription
    // hooks (direct DOM, single tag) so there is no second source to conflict with.
    const kwMeta = document.querySelector('meta[name="keywords"]');
    if (kwMeta) kwMeta.setAttribute('content', t('seo.keywords'));
    document.documentElement.lang = lang;
  }, [lang, t]);

  return null;
}
